import React from 'react';
import styled from 'styled-components';

const LogoImage = styled.img.attrs({
  className: 'laliga-logo'
})`
  height: 40px;
  width: auto;
  object-fit: contain;
  
  @media (max-width: 1024px) {
    height: 32px;
  }
  
  @media (max-width: 768px) {
    height: 28px;
  }
  
  @media (max-width: 480px) {
    height: 24px;
  }
`;

interface LaLigaLogoProps {
  className?: string;
}

const LaLigaLogo: React.FC<LaLigaLogoProps> = ({ className }) => {
  return (
    <LogoImage 
      src="/logos/LIGA-HYPERMOTION-logo.png" 
      alt="LaLiga Hypermotion" 
      className={className}
    />
  );
};

export default LaLigaLogo;